import React from 'react'

import { Box, Paper } from '@material-ui/core'

import {
  BannerTitle,
  BannerDescription,
  BannerPortalRow,
  BannerActionButton,
} from '..'

import usePrimaryBannerPreview from 'hooks/usePrimaryBannerPreview'

import styles from './styles'

const DefaultBannerLayout = () => {
  const { isCompact, isMobile, isFixed, hideRejectButton } =
    usePrimaryBannerPreview()

  const useStyles = styles(isCompact, isMobile, isFixed)
  const classes = useStyles()

  return (
    <Paper className={classes.paperContainer}>
      <BannerTitle />
      <Box className={classes.textBlock}>
        <BannerDescription />
        <BannerPortalRow />
      </Box>
      <Box className={classes.buttonsContainer}>
        <BannerActionButton kind="settings" />
        {!hideRejectButton && <BannerActionButton kind="reject" />}
        <BannerActionButton kind="accept" />
      </Box>
    </Paper>
  )
}

export default DefaultBannerLayout
